import { prefix } from "../../design-tokens/meta";
import { chevronDown } from "../../js/helpers/built-in-icons";

export const componentName = "AccordionItem";

export const componentClasses = Object.freeze({
    wrapper: `${prefix}accordion__item`,
    focus: `${prefix}accordion__item--focus`,
    expanded: `${prefix}accordion__item--expanded`,
    inactive: `${prefix}accordion__item--inactive`,
    collapsing: `${prefix}accordion__item--collapsing`,
    expanding: `${prefix}accordion__item--expanding`,
    heading: `${prefix}accordion__heading`,
    button: `${prefix}accordion__button`,
    icon: `${prefix}accordion__icon`,
    content: `${prefix}accordion__content`,
    body: `${prefix}accordion__body`,
});

export const views = Object.freeze({
    wrapper: {
        expanded: { classList: [`${componentClasses.expanded}`, `!${componentClasses.expanding}`] },
        collapsed: {
            classList: [`!${componentClasses.expanded}`, `!${componentClasses.collapsing}`],
        },
        expanding: {
            classList: [`${componentClasses.expanding}`, `!${componentClasses.collapsing}`],
        },
        collapsing: {
            classList: [`!${componentClasses.expanding}`, `${componentClasses.collapsing}`],
        },
        focus: { classList: [componentClasses.focus] },
        rest: { classList: [`!${componentClasses.focus}`] },
        inactive: {
            classList: [componentClasses.inactive],
        },
    },
    button: {
        expanded: {
            attrs: {
                "aria-expanded": "true",
            },
        },
        collapsed: {
            attrs: {
                "aria-expanded": "false",
            },
        },
        inactive: {
            attrs: { disabled: "disabled" },
        },
    },
    content: {
        expanded: {
            attrs: { "aria-hidden": "false" },
        },
        collapsed: {
            attrs: { "aria-hidden": "true" },
        },
    },
});

export const icons = {
    chevron: chevronDown,
};
